<template>
  <!-- 手機「目前選配登記」進熱度圖的兩步引導：Step1 選配試算提醒 → Step2 選配圖例說明 -->
  <div class="ur-sel-modal-overlay">
    <div class="ur-sel-modal-box">
      <!-- Step 1：選配試算提醒 -->
      <template v-if="step === 1">
        <div class="ur-sel-modal-body">
          <h3 class="ur-sel-modal-title">{{ $t('URBANRENEWAL_SELECT.DIALOG.INTRO_TITLE') }}</h3>
          <p class="ur-sel-modal-text ur-sel-gi-notice">{{ $t('URBANRENEWAL_SELECT.DIALOG.GRID_NOTICE') }}</p>
        </div>
        <div class="ur-sel-modal-footer">
          <button class="ur-sel-modal-btn ur-sel-modal-btn-primary" type="button" @click="step = 2">
            {{ $t('URBANRENEWAL_SELECT.DIALOG.GRID_NEXT') }}
          </button>
        </div>
      </template>

      <!-- Step 2：選配圖例說明 -->
      <template v-else>
        <div class="ur-sel-modal-body">
          <h3 class="ur-sel-modal-title">{{ $t('URBANRENEWAL_SELECT.DIALOG.LEGEND_TITLE') }}</h3>
          <div class="ur-sel-gi-legend">
            <span class="ur-sel-gi-legend-item">
              <span class="ur-sel-gi-dot" style="background:#FFFFFF;border:1px solid #888888;"></span>
              {{ $t('URBANRENEWAL_SELECT.GRID.LGD_NONE') }}
            </span>
            <span class="ur-sel-gi-legend-item">
              <span class="ur-sel-gi-dot" style="background:#bde3f5;border:1px solid #1A6894;"></span>
              {{ $t('URBANRENEWAL_SELECT.GRID.LGD_ONE') }}
            </span>
            <span class="ur-sel-gi-legend-item">
              <span class="ur-sel-gi-dot" style="background:#f4bec2;border:1px solid #922B21;"></span>
              {{ $t('URBANRENEWAL_SELECT.GRID.LGD_MULTI') }}
            </span>
          </div>
        </div>
        <div class="ur-sel-modal-footer">
          <button class="ur-sel-modal-btn ur-sel-modal-btn-primary" type="button" @click="$emit('done')">
            {{ $t('URBANRENEWAL_SELECT.DIALOG.LEGEND_ENTER') }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UrbanRenewalSelectGridIntroDialog',
  data() {
    return { step: 1 };
  },
};
</script>
